<script setup lang="ts">
import { NodeViewWrapper, type NodeViewProps } from '@tiptap/vue-3'

const props = defineProps<NodeViewProps>()

const label = computed(() => {
  const { name, label } = props.node.attrs as { name: string; label: string | null }
  const getLabel = props.extension.options.getLabel as (name: string) => string
  return label || getLabel(name)
})
</script>

<template>
  <NodeViewWrapper as="span" class="variable-tag">
    {{ label }}
  </NodeViewWrapper>
</template>

<style>
@reference "@/input.css";

.variable-tag {
  @apply inline-flex items-center px-2 py-0.5 mx-0.5 bg-muted border border-border rounded text-sm font-medium text-foreground-secondary cursor-default select-none;
}
</style>
